"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _AnimationWrapper = _interopRequireDefault(require("./AnimationWrapper"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function useAnimation(props) {
  const [dismissing, setDismissing] = (0, _react.useState)(false);
  const animationProps = Object.assign(Object.assign({}, props), {
    dismissing
  });
  return {
    AnimationWrapper: _AnimationWrapper.default,
    animationProps,
    dismiss: () => setDismissing(true)
  };
}
var _default = exports.default = useAnimation;